module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher"
    }
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_l"
  }, [_c('div', {
    staticClass: "tea_nav_title"
  }, [_vm._v(_vm._s(_vm.showPage.collegeMember))]), _vm._v(" "), _c('div', {
    staticClass: "tea_nav"
  }, [_c('ul', [_c('li', {
    class: _vm.on[11],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(11);
        _vm.selectTitle(11);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.honoraryProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[1],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(1);
        _vm.selectTitle(1);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.professor))]), _vm._v(" "), _c('li', {
    class: _vm.on[2],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(2);
        _vm.selectTitle(2);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.associateProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[3],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(3);
        _vm.selectTitle(3);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.assistantProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[5],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(5);
        _vm.selectTitle(5);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.fullTimeLecturer))]), _vm._v(" "), _c('li', {
    class: _vm.on[6],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(6);
        _vm.selectTitle(6);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[7],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(7);
        _vm.selectTitle(7);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctAssociateProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[8],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(8);
        _vm.selectTitle(8);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctAssistantProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[9],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(9);
        _vm.selectTitle(9);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctLecture))]), _vm._v(" "), _c('li', {
    class: _vm.on[10],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(10);
        _vm.selectTitle(10);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.teachingAssistant))])])])]), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "tea_r"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showTitle()))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "tea_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.teacherSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tea_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("GO")])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt15"
  }, _vm._l((_vm.teachers), function(teacher, index) {
    return (teacher.dept === 1 || teacher.dept === 2) ? _c('div', {
      key: index,
      staticClass: "tea_m"
    }, [_vm._v("\n          " + _vm._s(_vm.returnDept(teacher.dept)) + " / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher)
        }
      }
    }, [_vm._v(_vm._s(teacher.nameCh))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_g"
  }, [_vm._v(_vm._s(_vm.showPage.teacherMemberCount) + " " + _vm._s(_vm.teachers.length) + " " + _vm._s(_vm.showPage.people))]), _vm._v(" "), _c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li"
  }, _vm._l((_vm.teachers), function(teacher, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "tea_li_l"
    }, [(teacher.profileImage) ? _c('img', {
      attrs: {
        "src": teacher.profileImage
      }
    }) : _c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tea_li_r"
    }, [_c('div', {
      staticClass: "tea_lititle"
    }, [_vm._v(_vm._s(teacher.nameEn) + " " + _vm._s(teacher.nameCh))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showTitle()))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(teacher.office) + " / " + _vm._s(teacher.tel) + " / " + _vm._s(teacher.email))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v("Office Hour : " + _vm._s(teacher.advisory))]), _vm._v(" "), _c('div', {
      staticClass: "tea_p"
    }, [_c('ul', [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 0)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.personalInformation))])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.educationCourses))])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 2)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.awardsExperiences))])]), _vm._v(" "), _vm._l((_vm.teachercustoms(teacher)), function(custom, index) {
      return _c('li', {
        key: index
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'teacher_custom',
            params: {
              custom: index,
              teacherid: teacher.id
            }
          }
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.showName(custom)) + "\n                    ")])], 1)
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.teachers.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "teacher": _vm.teacher
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e795422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher.vue
// module id = 1242
// module chunks = 4